// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"183":"b3c4d607","688":"7fe95281"}[chunkId] + ".chunk.css";
};